import { fetchAdministrationMarketplaceOpportunity } from "../../../api/administrationMarketplace";
import { createKeyedResourceLoader } from "../../state/keyedResourceLoader";
import type { MarketplaceAdministrationSlice, MarketplaceOpportunityDetailSlice } from "./types";

const loader = createKeyedResourceLoader();

export const marketplaceOpportunityDetailInitialState = { opportunityDetails: {} };
export const resetMarketplaceOpportunityDetailRequests = loader.clear;

export const createMarketplaceOpportunityDetailSlice:
MarketplaceAdministrationSlice<MarketplaceOpportunityDetailSlice> = (set, get) => ({
  ...marketplaceOpportunityDetailInitialState,
  replaceOpportunityDetail: (data) => {
    const key = data.opportunity.id;
    loader.invalidate(key);
    set(state => ({ opportunityDetails: { ...state.opportunityDetails, [key]: { data, hydrated: true, loading: false, error: "" } } }));
  },
  loadOpportunityDetail: (opportunityId, options = {}) => {
    const current = get().opportunityDetails[opportunityId];
    return loader.load({
      key: opportunityId,
      force: options.force,
      cached: Boolean(current?.hydrated),
      request: () => fetchAdministrationMarketplaceOpportunity(opportunityId),
      onStart: () => set((state) => ({ opportunityDetails: { ...state.opportunityDetails, [opportunityId]: { data: current?.data || null, hydrated: current?.hydrated || false, loading: true, error: "" } } })),
      onSuccess: (data) => set((state) => ({ opportunityDetails: { ...state.opportunityDetails, [opportunityId]: { data, hydrated: true, loading: false, error: "" } } })),
      onError: (error) => set((state) => ({ opportunityDetails: { ...state.opportunityDetails, [opportunityId]: { data: current?.data || null, hydrated: current?.hydrated || false, loading: false, error } } })),
      onFinish: () => set((state) => state.opportunityDetails[opportunityId] ? ({ opportunityDetails: { ...state.opportunityDetails, [opportunityId]: { ...state.opportunityDetails[opportunityId], loading: false } } }) : state),
      errorMessage: "Unable to load Marketplace opportunity.",
    });
  },
});
